import React from "react";
import { View, StyleSheet } from "react-native";

import { FILE_TYPE } from "consts";
import { getAddedFiles } from "state/modules/response/selectors";
import { MediaPreview, CameraButton, AudioButton } from "components";
import { Device } from "utils";

export const MediaQuestion = props => {
  const { question, selectedOptions, scrollToEnd } = props;
  const { addOptionFile, removeOptionFile } = props;
  return question.options.map(option => {
    const { allow_photo, allow_video, allow_audio } = option;

    const selectedOption = selectedOptions[option.virtual_id] || {};
    const { mediaFiles, audioFile } = getAddedFiles(selectedOption);

    const addFile = (file, type) => {
      addOptionFile(question, option, file, type);
      setTimeout(() => scrollToEnd(), 50);
    };
    const removeFile = id => removeOptionFile(question, option, id);

    return (
      <>
        <View style={styles.container}>
          {mediaFiles.map(file => {
            if (
              file.type === FILE_TYPE.VIDEO ||
              file.type === FILE_TYPE.IMAGE
            ) {
              return (
                <MediaPreview
                  key={file.id}
                  media={file}
                  remove={() => removeFile(file.id)}
                />
              );
            }
          })}
        </View>
        {(allow_photo || allow_video) && (
          <CameraButton
            video={allow_video}
            photo={allow_photo}
            onCapture={addFile}
          />
        )}
        {allow_audio && Device.IS_WEB_AUDIO_SUPPORTED && (
          <AudioButton
            savedClip={audioFile.uri}
            onCapture={addFile}
            removeFile={() => removeFile(audioFile.id)}
          />
        )}
      </>
    );
  });
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
  },
});
